import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const POSSystemFeatures = () => {
  const features = [
    {
      icon: '🛍️',
      title: 'Retail Management',
      description:
        'Complete retail solution with inventory tracking, barcode scanning, and multi-location support.'
    },
    {
      icon: '🍽️',
      title: 'Restaurant & Hospitality',
      description:
        'Table management, kitchen display systems, and seamless order processing for restaurants.'
    },
    {
      icon: '📊',
      title: 'Advanced Analytics',
      description:
        'Real-time reporting, sales analytics, and business intelligence to drive growth.'
    },
    {
      icon: '💳',
      title: 'Payment Processing',
      description:
        'Accept all payment methods including cards, mobile payments, and digital wallets.'
    },
    {
      icon: '👥',
      title: 'Customer Management',
      description:
        'Build customer relationships with loyalty programs and detailed customer profiles.'
    },
    {
      icon: '☁️',
      title: 'Cloud-Based',
      description:
        'Access your business data anywhere, anytime with secure cloud infrastructure.'
    }
  ]

  return (
    <section style={{ padding: '80px 0', backgroundColor: 'var(--grey)' }}>
      <Container>
        <Row>
          <Col lg={12}>
            <div style={{ textAlign: 'center', marginBottom: '60px' }}>
              <h6
                className="head"
                style={{
                  color: 'var(--primary)',
                  marginBottom: '20px'
                }}
              >
                FEATURES & CAPABILITIES
              </h6>
              <h2
                style={{
                  fontSize: '2.5rem',
                  fontWeight: '700',
                  color: 'var(--darkblue)',
                  marginBottom: '20px'
                }}
              >
                Powerful Features for Every Business
              </h2>
              <p
                className="text"
                style={{
                  fontSize: '16px',
                  color: '#666',
                  maxWidth: '600px',
                  margin: '0 auto'
                }}
              >
                Our POS system comes packed with features designed to simplify
                operations and boost your business efficiency.
              </p>
            </div>
          </Col>
        </Row>

        <Row>
          {features.map((feature, index) => (
            <Col
              lg={4}
              md={6}
              sm={12}
              key={index}
              style={{ marginBottom: '40px' }}
            >
              <div
                style={{
                  backgroundColor: 'var(--white)',
                  padding: '40px 30px',
                  borderRadius: '15px',
                  textAlign: 'center',
                  height: '100%',
                  boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)'
                  e.currentTarget.style.boxShadow =
                    '0 15px 40px rgba(85, 105, 193, 0.15)'
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow =
                    '0 5px 20px rgba(0,0,0,0.08)'
                }}
              >
                <div
                  style={{
                    fontSize: '60px',
                    marginBottom: '25px',
                    display: 'block'
                  }}
                >
                  {feature.icon}
                </div>
                <h4
                  style={{
                    color: 'var(--darkblue)',
                    fontWeight: '600',
                    marginBottom: '20px',
                    fontSize: '1.3rem'
                  }}
                >
                  {feature.title}
                </h4>
                <p
                  style={{
                    color: '#666',
                    lineHeight: '1.6',
                    fontSize: '15px',
                    margin: 0
                  }}
                >
                  {feature.description}
                </p>
              </div>
            </Col>
          ))}
        </Row>

        {/* Call to Action Section */}
        <Row style={{ marginTop: '60px' }}>
          <Col lg={12}>
            <div
              style={{
                background: `linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%)`,
                padding: '60px 40px',
                borderRadius: '20px',
                textAlign: 'center',
                color: 'var(--white)'
              }}
            >
              <h3
                style={{
                  fontSize: '2rem',
                  fontWeight: '700',
                  marginBottom: '20px',
                  color: 'var(--white)'
                }}
              >
                Ready to Transform Your Business?
              </h3>
              <p
                style={{
                  fontSize: '16px',
                  marginBottom: '30px',
                  opacity: '0.9',
                  maxWidth: '500px',
                  margin: '0 auto 30px auto'
                }}
              >
                Join thousands of businesses already using SMG POS system to
                streamline operations and increase profitability.
              </p>
              <button
                style={{
                  backgroundColor: 'var(--white)',
                  color: 'var(--primary)',
                  padding: '15px 40px',
                  borderRadius: '50px',
                  border: 'none',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'translateY(-2px)'
                  e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)'
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'translateY(0)'
                  e.target.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)'
                }}
              >
                Get Started Today
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default POSSystemFeatures
